/* eslint-disable camelcase */
import React from 'react';
import {
  CopyIcon,
  CountryCropMapIcon,
  FleetTelematicsIcon,
  IntegrationsIcon,
  CropManagementIcon,
  FarmOperationsIcon,
  ApiCustomDashboardIcon,
  SystemConfigurationIcon,
  ProductServicesIcon,
  ServiceDeskIcon,
} from 'components/cwo-icons';

const cwoModuleConfig = {
  telematics: {
    icon: <FleetTelematicsIcon />,
  },
  integrations: {
    icon: <IntegrationsIcon />,
  },
  other: {
    icon: <CopyIcon color="#000000" />,
  },
  crop_management: {
    icon: <CropManagementIcon />,
  },
  farm_operations: {
    icon: <FarmOperationsIcon />,
  },
  api: {
    icon: <ApiCustomDashboardIcon />,
  },
  system_configuration: {
    icon: <SystemConfigurationIcon />,
  },
  p_plus_services: {
    icon: <ProductServicesIcon />,
  },
  crop_map: {
    icon: <CountryCropMapIcon />,
  },
  service_desk: {
    icon: <ServiceDeskIcon color="#000000" size={24} />,
  },
};
export default cwoModuleConfig;
